import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './UsersInfo.module.less';
import TeamIcon from '../../../../Assets/teams-blue.svg';
import XIcon from '../../../../Assets/red-x.svg';
import Export from '../../../../Assets/export.png';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import AppConfig from '../../../../Config/AppConfig';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import { ProfileSelectors } from '../../../../Redux/modules/profile/selectors';
import { AppSelectors } from '../../../../Redux/modules/app/selectors';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';

const BulkActionsBar = (props) => {
  const selectionColumn = props.headerGroups[0].headers.find((column) => column.id === 'selection');
  const selectedIds = props.selectedFlatRows.map((selectedRow) => selectedRow.original.id);
  const hasPermissionActivationLink = AppConfig.ACTIVATION_LINKS_ENABLED;

  const onlyAdminSelected = () => {
    return props.selectedFlatRows.length === 1 && props.selectedFlatRows[0].original.email === props.currentLoggedEmail;
  };

  return (
    <thead>
      <tr {...props.headerGroups[0].getHeaderGroupProps()}>
        <th
          className={styles.selectionColumn}
          {...selectionColumn?.getHeaderProps(selectionColumn?.getSortByToggleProps())}
        >
          {selectionColumn.render('Header')}
        </th>
        <th colSpan="5" scope="colgroup">
          <div className={styles.bulkActions}>
            <div>{`${props.selectedFlatRows.length} ${gettext('Selected')}`}</div>
            {props.selectedFlatRows.length === props.pageSize && props.dataLength > props.selectedFlatRows.length && (
              <button
                type="button"
                className={[styles.selectAllNote, styles.bulkActionTag].join(' ')}
                onClick={() => {
                  props.setAllSelect();
                  props.toggleAllRowsSelected();
                }}
                id="select-all-button"
              >
                {`${gettext('select all')} ${props.dataLength}`}
              </button>
            )}
            {props.teams.length > 0 && props.isTeamManagement && (
              <div className={styles.bulkAction}>
                <img src={TeamIcon} alt="" />
                <button
                  type="button"
                  className={styles.bulkActionTag}
                  onClick={() => props.clickedBulkAssignToTeamsButton()}
                  id="bulk-assign-to-teams-button"
                >
                  {gettext('Assign to teams')}
                </button>
              </div>
            )}

            <div />
            {hasPermissionActivationLink && (
              <div className={styles.bulkAction}>
                <img src={Export} alt="" width={20} />
                <AnalyticsHandler
                  eventName={AnalyticsEventNames.EXPORT_ACTIVATION_LINKS}
                  eventData={{
                    manipulatedUsers: selectedIds.toString(),
                    manipulatedUsersEmails: props.selectedFlatRows
                      .map((selectedRow) => selectedRow.original.email)
                      .toString(),
                  }}
                >
                  <button
                    type="button"
                    className={styles.bulkActionTag}
                    onClick={() => props.exportActivationIds(selectedIds)}
                    id="bulk-export-button"
                  >
                    {gettext('Export activation links')}
                  </button>
                </AnalyticsHandler>
              </div>
            )}
            {!onlyAdminSelected() && (
              <div className={styles.bulkAction}>
                <img src={XIcon} alt="" />
                <button
                  type="button"
                  className={[styles.bulkActionTag, styles.remove].join(' ')}
                  onClick={() => {
                    props.clickedRemoveUsersButton();
                  }}
                  id="bulk-remove-button"
                >
                  {gettext('Remove')}
                </button>
              </div>
            )}
          </div>
        </th>
      </tr>
    </thead>
  );
};

const mapDispatchToProps = {
  clickedRemoveUsersButton: UsersActions.clickedRemoveUsersButton,
  clickedBulkAssignToTeamsButton: UsersActions.clickedBulkAssignToTeamsButton,
  exportActivationIds: UsersActions.exportActivationIds,
};

const mapStateToProps = (state) => {
  return {
    currentLoggedEmail: ProfileSelectors.profileEmailSelector(state),
    teams: UsersSelectors.teamsSelector(state),
    isTeamManagement: AppSelectors.isTeamManagementSelector(state),
  };
};

BulkActionsBar.propTypes = {
  headerGroups: PropTypes.array,
  selectedFlatRows: PropTypes.array,
  currentLoggedEmail: PropTypes.string,
  clickedRemoveUsersButton: PropTypes.func,
  pageSize: PropTypes.number,
  dataLength: PropTypes.number,
  toggleAllRowsSelected: PropTypes.func,
  clickedBulkAssignToTeamsButton: PropTypes.func,
  exportActivationIds: PropTypes.func,
  setAllSelect: PropTypes.func,
  teams: PropTypes.array,
  isTeamManagement: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkActionsBar);
